import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faBox, faClock, faHashtag } from "@fortawesome/free-solid-svg-icons";

const PurchaseRequest = ({purchases_request}) => {
    const [expandedOrder, setExpandedOrder] = useState(null);

    const toggleExpand = (index) => {
        setExpandedOrder(expandedOrder === index ? null : index);
    };

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    return (
        <div className="max-w-6xl mx-xl-auto mt-8 mx-4 p-4 sm:p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <h2 className="text-xl sm:text-2xl font-bold mb-5 text-ecoprimary1 border-b pb-3 flex items-center gap-2">
                <FontAwesomeIcon icon={faClock} className="text-base" />
                Compras en proceso
            </h2>

            {purchases_request && purchases_request.length > 0 ? (
                <div className="flex flex-col gap-3">
                    {purchases_request.map((purchase, index) => (
                        <div
                            key={index}
                            className="border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 hover:border-ecoprimary1/40 hover:shadow-sm"
                        >
                            {/* Compact order header - always visible */}
                            <div
                                className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 sm:p-4 bg-gradient-to-r from-gray-50 to-white cursor-pointer gap-2 sm:gap-4"
                                onClick={() => toggleExpand(index)}
                            >
                                <div className="flex items-center gap-3 sm:gap-4 flex-1 min-w-0">
                                    {/* Order code */}
                                    <div className="flex items-center gap-2 shrink-0">
                                        <div className="w-8 h-8 sm:w-9 sm:h-9 bg-ecoprimary1/10 rounded-lg flex items-center justify-center">
                                            <FontAwesomeIcon icon={faHashtag} className="text-ecoprimary1 text-xs sm:text-sm" />
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-400 mb-0 leading-none">Pedido</p>
                                            <p className="text-sm font-bold text-ecoprimary1 mb-0">#{purchase.code}</p>
                                        </div>
                                    </div>

                                    {/* Mini product thumbnails */}
                                    <div className="flex items-center gap-1 ml-2">
                                        {purchase.products.slice(0, 4).map((product, pIndex) => (
                                            <div
                                                key={pIndex}
                                                className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg border border-gray-200 overflow-hidden bg-gray-50 flex-shrink-0 shadow-sm"
                                            >
                                                <img
                                                    src={product.product?.first_image}
                                                    alt=""
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                        ))}
                                        {purchase.products.length > 4 && (
                                            <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg border border-gray-200 bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                <span className="text-xs font-semibold text-gray-500">+{purchase.products.length - 4}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto justify-between sm:justify-end">
                                    {/* Date */}
                                    {purchase.created_at && (
                                        <span className="text-xs text-gray-400 whitespace-nowrap hidden sm:inline">
                                            {formatDate(purchase.created_at)}
                                        </span>
                                    )}

                                    {/* Status badge */}
                                    <span className="px-2.5 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-semibold border border-yellow-200 whitespace-nowrap">
                                        {purchase.delivery_state ? purchase.delivery_state.name : 'Pendiente'}
                                    </span>

                                    {/* WhatsApp button - compact */}
                                    {purchase.whatsapp && (
                                        <a
                                            href={purchase.whatsapp}
                                            target="_blank"
                                            className="bg-[#25D366] hover:bg-[#1ebd5a] text-white p-2 flex items-center justify-center rounded-lg transition-colors no-underline shadow-sm shrink-0"
                                            rel="noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                                        </a>
                                    )}

                                    {/* Expand chevron */}
                                    <div className="w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center shrink-0 transition-colors hover:bg-gray-200">
                                        <FontAwesomeIcon
                                            icon={expandedOrder === index ? faChevronUp : faChevronDown}
                                            className="text-gray-500 text-xs transition-transform duration-300"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Expanded products - collapsible */}
                            <div
                                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                                    expandedOrder === index ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
                                }`}
                            >
                                <div className="border-t border-gray-100 px-3 sm:px-4 py-3 bg-gray-50/50">
                                    <p className="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wider">
                                        <FontAwesomeIcon icon={faBox} className="mr-1.5" />
                                        {purchase.products.length} producto{purchase.products.length !== 1 ? 's' : ''}
                                    </p>
                                    <div className="flex flex-col gap-2">
                                        {purchase.products.map((product, pIndex) => (
                                            <div
                                                key={pIndex}
                                                className="flex items-center gap-3 bg-white rounded-lg p-2 sm:p-2.5 border border-gray-100 hover:border-gray-200 transition-colors"
                                            >
                                                {/* Product image */}
                                                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-lg overflow-hidden bg-gray-50 border border-gray-100 flex-shrink-0">
                                                    <img
                                                        src={product.product?.first_image}
                                                        alt={product.product?.name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                {/* Product info */}
                                                <div className="flex-1 min-w-0">
                                                    <p className="text-sm font-medium text-gray-700 mb-0 truncate">
                                                        {product.product?.name}
                                                    </p>
                                                    <div className="flex items-center gap-2 mt-0.5">
                                                        {product.pivot?.quantity && (
                                                            <span className="text-xs text-gray-400">
                                                                Cant: {product.pivot.quantity}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* Price */}
                                                <div className="text-right shrink-0">
                                                    <p className="text-sm font-bold text-ecoprimary1 mb-0">
                                                        Bs {product.pivot?.price || product.product?.price}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="bg-blue-50 text-blue-800 border border-blue-100 p-6 rounded-xl flex flex-col items-center justify-center min-h-[120px]">
                    <FontAwesomeIcon icon={faBox} className="text-2xl text-blue-300 mb-2" />
                    <p className="mb-0 font-medium text-sm">No hay compras en proceso</p>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    purchases_request: state.User.purchases_request,
});

export default connect(mapStateToProps, {})(PurchaseRequest);
